import React, { memo, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import MapIcon from '../../assets/img/svg/Location-icon.svg'
import { appendImageURL, getLocationAddress } from '../../helper/function'
import { getGoogleMapUrl } from '../../redux/slices/clientSlice'
import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'

// import optional lightbox plugins
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen'
import Slideshow from 'yet-another-react-lightbox/plugins/slideshow'
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails'
import Zoom from 'yet-another-react-lightbox/plugins/zoom'
import Captions from 'yet-another-react-lightbox/plugins/captions'
import 'yet-another-react-lightbox/plugins/thumbnails.css'
import 'yet-another-react-lightbox/plugins/captions.css'

const CleaningPlacePhoto = ({ scheduledPropertiesComplete, column }) => {
  const dispatch = useDispatch()
  const [addresses, setAddresses] = useState({})
  const [isOpen, setIsOpen] = useState(false) // For managing lightbox open state
  const [currentImageIndex, setCurrentImageIndex] = useState(0) // For tracking current image in preview
  const [images, setImages] = useState([])

  useEffect(() => {
    if (scheduledPropertiesComplete) {
      const parsedScheduledImages = scheduledPropertiesComplete?.map((image) => JSON.parse(image)) || []

      setImages(parsedScheduledImages)
    }
  }, [scheduledPropertiesComplete])

  useEffect(() => {
    if (images) {
      images?.forEach((item, index) => {
        const metaInformation = item?.meta?.imagesDetails
        if (metaInformation?.location) {
          const { Latitude, Longitude } = metaInformation.location
          // Fetch address for each image's location
          getLocationAddress(Latitude, Longitude)
            .then(({ address, placeId }) => {
              setAddresses((prev) => ({
                ...prev,
                [index]: { address, placeId }
              }))
            })
            .catch((error) => console.error(error))
        }
      })
    }
  }, [images])

  const onHandleClick = async (place_id) => {
    dispatch(getGoogleMapUrl(place_id))
      .then((reposne) => {
        if (reposne?.payload?.data?.data) {
          window.open(reposne?.payload?.data?.data, '_blank')
        }
      })
      .catch((error) => {
        console.error('Error fetching address:', error)
      })
  }

  // Function to open the lightbox and set the image index
  const openLightbox = (index) => {
    setCurrentImageIndex(index)
    setIsOpen(true)
  }

  return (
    <>
      <div className={`${column ? 'masonry_main_div_modal' : 'masonry_main_div'}`}>
        {images?.map((item, index) => {
          const metaInformation = item?.meta?.imagesDetails
          return (
            item?.s3Url && (
              <div
                className="masonry_item"
                key={index}
                onClick={() => {
                  openLightbox(index)
                }} // Open lightbox on image click>
              >
                <div className="clean_img_div">
                  <img
                    className="img-fluid w-100 main_img"
                    src={typeof item?.s3Url === 'string' ? appendImageURL(item?.s3Url) : appendImageURL(item.s3Url)}
                    alt={`Cleaning Image ${index + 1}`}
                  />
                  <div className="room_photos_contains">
                    {metaInformation ? (
                      <div className="room_photos_list_div">
                        <div className="room_photos_box">
                          <h6 className="masonry_h6">Lens</h6>
                          <p>{metaInformation.Lens || 'Unknown Lens'}</p>
                        </div>
                        <div className="room_photos_box">
                          <h6 className="masonry_h6">Date and Time</h6>
                          <p>
                            {new Date(metaInformation.date).toLocaleDateString('en-US', {
                              day: '2-digit',
                              month: 'short',
                              year: 'numeric'
                            })}{' '}
                            {new Date(metaInformation.date).toLocaleTimeString('en-US', {
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: true
                            })}
                          </p>
                        </div>
                        {addresses[index]?.address ? (
                          <div className="room_photos_box">
                            <h6 className="masonry_h6">Address</h6>
                            <p
                              title={addresses[index]?.address || ''}
                              style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 4,
                                WebkitBoxOrient: 'vertical'
                              }}
                            >
                              {addresses[index]?.address || ''}
                            </p>
                          </div>
                        ) : (
                          ''
                        )}
                        {addresses[index]?.address && (
                          <div
                            className="map_icon_div"
                            onClick={(e) => {
                              e.stopPropagation()
                              onHandleClick(addresses[index]?.placeId)
                            }}
                          >
                            <img className="img-fluid" src={MapIcon} alt="Location Icon" />
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="room_photos_list_div">
                        <div className="room_photos_box">
                          <h6 className="masonry_h6">No Metadata Found</h6>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )
          )
        })}
      </div>

      {/* Lightbox component to display the image in full screen */}
      <Lightbox
        open={isOpen} // Control the visibility of the lightbox
        close={() => setIsOpen(false)} // Close lightbox
        slides={images?.map((item) => {
          const metaInformation = item?.meta?.imagesDetails
          const description = metaInformation
            ? `Lens: ${metaInformation.Lens || 'Unknown Lens'}
       Date: ${new Date(metaInformation.date).toLocaleDateString('en-US', {
         day: '2-digit',
         month: 'short',
         year: 'numeric'
       })} ${new Date(metaInformation.date).toLocaleTimeString('en-US', {
         hour: '2-digit',
         minute: '2-digit',
         hour12: true
       })} 
      Address: ${addresses[images.indexOf(item)]?.address || 'Unknown Address'}`
            : null
          return {
            src: typeof item?.s3Url === 'string' ? appendImageURL(item?.s3Url) : appendImageURL(item.s3Url),
            // title: `Image ${images.indexOf(item) + 1}`, // Optional title for the slide
            description // Add description to the slide
          }
        })}
        index={currentImageIndex} // Show the clicked image in the lightbox
        plugins={[Captions, Fullscreen, Slideshow, Thumbnails, Zoom]}
      />
    </>
  )
}

export default memo(CleaningPlacePhoto)
